/**
 * 區域頁面模組
 */

//-----------------------------------------------------------------------
// 載入模組
import * as React from 'react';
import get from 'lodash/get';
import { useRecordContext, usePermissions, ReferenceField, Labeled } from 'react-admin';
import { List, Show, Edit, SimpleShowLayout, Datagrid, SimpleForm } from 'react-admin';
import { TextField, ShowButton, SelectInput } from 'react-admin';
import { downloadCSV, DataProvider } from 'react-admin';
import { ListEditButton, SaveOnlyToolbar } from '../lib/components';
import jsonExport from 'jsonexport/dist';

//-----------------------------------------------------------------------
// defines
import { COMMON_STATUS } from '../common/defines';
import { NamePairInfo } from '../common/interfaces';
import { MemberAuthInfo } from '../providers/authProvider';

//-----------------------------------------------------------------------
/** 區域狀態顯示欄位元件。 */

const regionStatusMap = new Map<string, string>();
const regionStatusList : NamePairInfo<string>[] =
[
	{ id: COMMON_STATUS.Enable,		name: "啟用"},
	{ id: COMMON_STATUS.Disable,	name: "停用"}
];

for(let status of regionStatusList)
	regionStatusMap.set(status.id, status.name);

export const RegionStatusField = (props: any) =>
{
	const { source } = props;
	const record = useRecordContext(props);

	return (<span className="MuiTypography-body2 MuiTypography-root">{regionStatusMap.get(get(record, source))}</span>);
}

RegionStatusField.defaultProps =
{
	label: '狀態',
	addLabel: true,
};

//-----------------------------------------------------------------------
/** 資料輸出功能。 */
const exporter = (records: any, fetchRelatedRecords: (data: any, field: string, resource: string) => Promise<any>, dataProvider: DataProvider) =>
{
	fetchRelatedRecords(records, 'sourceId', 'source').then((sources) =>
	{
		const data = records.map((record: any) =>
		({
			...record,
			sourceId: sources[record.sourceId].name
		}));

		return jsonExport(data,
		{
			headers	: [ 'id', 'sourceId', 'name', 'status' ],
			rename	: [ 'id', '資料來源', '名稱', '狀態' ]
		}, (err, csv) =>
		{
			downloadCSV("\ufeff" + csv, 'region');
		});
	});
};

/** 區域列表頁面。 */
export const RegionList = (props: any) =>
{
	let { permissions } = usePermissions();
	let	authInfo = permissions as MemberAuthInfo;

	return <List {...props} title='區域' exporter={exporter}>
		<Datagrid bulkActionButtons={false}>
			<TextField source='id' />
			<ReferenceField label="資料來源" source="sourceId" reference="source">
				<TextField source="name" />
			</ReferenceField>
			<TextField source='name' label='名稱' />
			<RegionStatusField source='status' />
			<ListEditButton edit={authInfo.regionEdit} />
			<ShowButton />
		</Datagrid>
	</List>;
};

/** 區域資訊頁面。 */
export const RegionShow = (props: any) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source='id' />
			<ReferenceField label="資料來源" source="sourceId" reference="source" sortBy='s_id'>
				<TextField source="name" />
			</ReferenceField>
			<TextField source='name' label='名稱' />
			<RegionStatusField source='status' />
		</SimpleShowLayout>
	</Show>
);

/** 區域編輯頁面。 */
export const RegionEdit = (props: any) => (
	<Edit {...props}>
		<SimpleForm toolbar={<SaveOnlyToolbar/>}>
			<Labeled label="ID"><TextField source='id' /></Labeled>
			<Labeled label="資料來源">
				<ReferenceField source="sourceId" reference="source" sortBy='s_id'>
					<TextField source="name" />
				</ReferenceField>
			</Labeled>
			<Labeled label="名稱"><TextField source='name' /></Labeled>
			<SelectInput source='status' choices={regionStatusList} label="狀態" />
		</SimpleForm>
	</Edit>
);
